import type { FAQItem } from "@/components/seo/faq-types";
import { Link } from "react-router-dom";

export const bathroomFaqItems: FAQItem[] = [
  {
    id: "1",
    question: "Are these kitchen products exclusively for commercial use?",
    answerText:
      "No, we offer both residential and commercial-grade kitchen products, with a wide range of options for homes and commercial settings.",
    answerNode: (
      <>
        No, we offer both residential and commercial-grade kitchen products, with a wide range of options for homes and commercial settings.{" "}
        <Link to="/about-us#team-finder" className="text-blue-600 underline hover:text-blue-800">
          Talk to us about the right fit for your build or project
        </Link>.
      </>
    ),
  },
  {
    id: "2",
    question: "Can you also supply to commercial kitchens like cafés, restaurants, and rest homes?",
    answerText:
      "We do. Alongside residential builds, we supply kitchens for hospitality, aged care, offices, and shared environments, including appliances suited to higher usage and compliance requirements. Let us know your environment, and we can provide recommendations and guide the spec.",
    answerNode: (
      <>
        We do. Alongside residential builds, we supply kitchens for hospitality, aged care, offices, and shared environments, including appliances suited to higher usage and compliance requirements. Let us know your environment, and we can provide recommendations and guide the spec.{" "}
        {/* <Link to="/about-us#team-finder" className="text-blue-600 underline hover:text-blue-800">
          Contact one of our dedicated account managers
        </Link> to learn more about what this looks like. */}
      </>
    ),
  },
  {
    id: "3",
    question: "Can I get everything for a kitchen in one place?",
    answerText:
      "Almost. Apart from cabinetry, we supply an extensive range of kitchen products, including cooking appliances, dishwashers, refrigeration, sinks, tapware, water filtration, water-heating taps, beverage centres, and even cookware and tableware.",
    answerNode: (
      <>
        Almost. Apart from cabinetry, we supply an extensive range of kitchen products, including cooking appliances, dishwashers, refrigeration, sinks, tapware, water filtration, water-heating taps, beverage centres, and even cookware and tableware.{" "}
        <Link to="/contact-us" className="text-blue-600 underline hover:text-blue-800">
          Explore complete kitchen solutions for your project
        </Link>.
      </>
    ),
  },
  {
    id: "4",
    question: "Can you deliver to site, and stage orders with the build?",
    answerText:
      "Yes, and we provide nationwide delivery across New Zealand, including staged deliveries aligned with your construction programme. If timeframes are critical to your project, you’ve come to the right place! Let’s chat about how we can best coordinate delivery timings for your project.",
    answerNode: (
      <>
        Yes, and we provide <strong>nationwide delivery across New Zealand</strong>, including staged deliveries aligned with your construction programme. If timeframes are critical to your project, you’ve come to the right place! <strong>Let’s chat about how we can best coordinate delivery timings for your project</strong>.{" "}
        {/* <Link to="/about-us#team-finder" className="text-blue-600 underline hover:text-blue-800">
          Ask for a project quote or comparison
        </Link>. */}
      </>
    ),
  },
  {
    id: "5",
    question: "What if we need more units or replacements later?",
    answerText:
      "We can prioritise consistent product ranges, making it easier to match appliances and fixtures across future stages or for replacements. On this note, we can absolutely work within your specified budgets and requirements.",
    answerNode: (
      <>
        We can prioritise consistent product ranges, making it easier to match appliances and fixtures across future stages or for replacements. On this note, we can absolutely work within your specified budgets and requirements.{" "}
        {/* <Link to="/about-us#team-finder" className="text-blue-600 underline hover:text-blue-800">
          Get confirmed delivery timelines with our commercial team
        </Link>. */}
      </>
    ),
  },
  
];